const icons = [
    { key: 'icon-arrow-forward', title: 'Arrow Forward' }
];

exports.icons = icons;